import { businessKey } from 'queryKeys';

export const OUTSOURCE_STUDIOS = 'outsource-studios';
export const outsourceStudiosQuery = businessKey.query(OUTSOURCE_STUDIOS);
export const model = outsourceStudiosQuery.exact();
export const list = outsourceStudiosQuery.grid();
export const mutations = outsourceStudiosQuery.mutations();
export const update = mutations.update();
export const create = mutations.create();
export const remove = mutations.delete();
